module.exports = __webpack_public_path__ + "img/dropdown-menu-solution-2-1.5ab37d96.png";